import { useForm } from "react-hook-form";
import React, { useState } from 'react';


export default function Form({setLoading}) {

  const [status, setStatus] = useState(null);

  const { register,  reset, formState: { errors, isValid }, handleSubmit } = useForm({
    mode: "onChange"
  });
  const onSubmit = async (data) => {
    setLoading(true);
    try {
    const response = await fetch(process.env.REACT_APP_POST_URL, {
    method: 'POST',
    headers: {
    'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
    });
      const result = await response.text();
      console.log('result', result)
      setStatus(result);
    } catch (error) {
      setStatus('Error sending message');
    }
    console.log(data);
    setLoading(false);
    reset()
    };

  return (
    <div className="login-box">
      <form className="max-w-full m-auto py-2 sm:py-6 xl:py-0" onSubmit={handleSubmit(onSubmit)}>
        <div className="user-box">
          <input 
            className="border-b-2 border-black pt-3 sm:pt-4 w-full mb-1 mt-3 background-color text-gray-700 outline-emerald-400"
            name="name"
            {...register("name", { required: true })} 
            aria-invalid={errors.name ? "true" : "false"}
            required
            onFocus={(e) => (e.target.placeholder = "")}
            onBlur={(e) => (e.target.placeholder = "Tell me your name")}
            placeholder="Tell me your name"
          />
          {errors.name?.type === 'required' && <p role="alert" className="text-red-600">Sorry, but your name is required</p>}
          <label className="text-gray-500 font-medium mt-3 code">Name</label>
        </div>

        <div className="user-box">
          <input 
            className="border-b-2 border-black pt-3 sm:pt-4 w-full mb-1 mt-3 background-color text-gray-700 outline-emerald-400"
            name="email"
            type="email"
            {...register("email", { 
              required: "Please input a valid email address",
              pattern: {
                value: /^\S+@\S+$/i,
                message: "Please input a valid email address"
              }
            })} 
            aria-invalid={errors.email ? "true" : "false"} 
            required
            onFocus={(e) => (e.target.placeholder = "")}
            onBlur={(e) => (e.target.placeholder = "Your email address")}
            placeholder="Your email address"
          />
          {errors.email && <p role="alert" className="text-red-600">{errors.email?.message}</p>}
          <label className="text-gray-500 font-medium mt-3 code">Email Address</label>
        </div>
          
        <div className="user-box mt-3">
          <textarea
            className={`border-solid border rounded py-2 sm:py-4 px-2 sm:px-3 mt-6 background-color w-full text-gray-700 ${
              errors.messages ? "border-red-600" : (isValid ? "border-emerald-400" : "border-black")
            }`}
            name="messages"
            rows={5}
            cols={5}
            {...register("messages", { required: "You haven't typed any message yet" })}
            aria-invalid={errors.messages ? "true" : "false"}
            required
            onFocus={(e) => (e.target.placeholder = "")}
            onBlur={(e) => (e.target.placeholder = "How can I help?")}
            placeholder="How can I help?"
            
          />
          {errors.messages && <p role="alert" className="text-red-600">{errors.messages?.message}</p>}
          <label className="text-gray-500 font-medium block mb-3 code">
            Message
          </label>
        </div>
          
        <button
          className={`mt-4 mb-6 w-full main-font border py-3 px-6 font-normal text-md rounded leading-7 tracking-widest spinner ${
            isValid ? "border-2 border-black btn5 hover:text-white delay-500" : "bg-blue border border-black text-black button-hover-color-not-allowed"
          }`}
          style={{textAlign: "center"}}
          type="submit"
          disabled={!isValid}
        >
          
          {isValid ? "Send Message" : "Send Message"}
          
        </button>
        {status && <p>{status}</p>}
      </form>
    </div>
  );
}